import Observer from 'common/scripts/observer';
import tmplComplexList from '../complex/templates/complex-sort-parking.twig';
import tmplFlatsList from '../flat/templates/flat-list.twig';
import {Utils} from 'common/scripts/utils';

const observer = new Observer();

class ParametricComplex {
    constructor(options) {
        this.options = options;
        this.element = options.element;

        this.sort = {
            sort : 'price',
            order: 'asc'
        };

        this.isPopupOpen = false;
        this.sortPopupBtns = [];

        this.sortSelector = '.j-sort';
        this.activeClass = 'is-active';
        this.loadingClass = 'is-loading';

        /**
         * CSS-класс для сортировки, означает сортировку от большего к меньшему
         * @type {string}
         */
        this.descClass = 'is-desc';

        /**
         * CSS-класс для сортировки, означает сортировку от большего к меньшему
         * @type {string}
         */
        this.ascClass = 'is-asc';

        /**
         * Флаг, показывающий, открыт ли скрытый блок.
         * Если открыт - подгружаем квартиры с сервера,
         * если нет - открываем его
         * @type {boolean}
         */
        this.beforeUpload = false;

        /**
         * Число квартир: по умолчанию 10 в скрытом блоке (а 3 - в открытом)
         * @type {Number}
         */
        this.hiddenFlatsCount = 10;

        /**
         * Корректирующее значение числа квартир
         * @type {Number}
         */
        this.newCount = 0;
    }

    init() {
        this._bindContext();
        this._initElements();
        this._subscribes();
        this._bindEvents();

        if (this.options.ready) {
            this.options.ready(this);
        }
    }

    destroy() {
        this._unbindEvents();
    }

    runLoading(isLoadingButton = false) {
        this.element.classList.add(this.loadingClass);

        if (isLoadingButton && this.showMoreBtn) {
            this.showMoreBtn.classList.add(this.loadingClass);
        }
    }

    stopLoading() {
        this.element.classList.remove(this.loadingClass);

        if (this.showMoreBtn) {
            this.showMoreBtn.classList.remove(this.loadingClass);
        }
    }

    setSortComplex(data) {
        if (!data.buildings.length) {
            return;
        }

        const buildingsList = this.element.querySelector('.parametric-complex__flats-list');
        const buildings = Array.from(buildingsList.querySelectorAll('.parametric-complex__flats-list_item'));

        if (buildings.length) {
            buildings.forEach((elem) => {
                Utils.removeElement(elem);
            });
        }

        Utils.insetContent(buildingsList, tmplComplexList(data));
    }

    /**
     * Обновляет/добавляет список квартир
     * @param {Array} flats - массив объектов, содержащий информацию о квартирах
     * @param {Boolean} isReplace - флаг, true, если необходимо заменить текущий список квартир
     * @param {Boolean} hasHiddenBlock - флаг
     */
    setFlatsList(flats, isReplace = false, hasHiddenBlock = false) {
        if (!flats || !flats.length) {
            return;
        }

        if (isReplace) {
            Utils.clearHtml(this.flatsList);
        }

        Utils.insetContent(this.flatsList, tmplFlatsList({flats,
            hasHiddenBlock}));
        observer.publish('parametric:updateFlats', this);

        // if (!isReplace) {
        //     this._sendDataLayerFlats(flats);
        // }

        this._initElements();
        this._bindEvents();

        this.beforeUpload = false;
    }

    _toggleMoreBtnState() {
        if (!this.showMoreBtn) {
            return;
        }

        // const totalCount = this.element.querySelector('.j-parametric__total-count').innerHTML;
        this.hiddenFlatsCount = this.hiddenFlatsList.querySelectorAll('.parametric-flat').length;

        // if (Number(totalCount) <= Number(this.hiddenFlatsCount + 3)) {
        //     this.showMoreBtn.classList.remove('is-hidden');
        // } else {
        //     this.showMoreBtn.classList.add('is-hidden');
        // }
    }

    renameButton() {
        if (!this.showMoreBtn) {
            return;
        }

        const totalCount = this.element.querySelector('.j-parametric__total-count').innerHTML;

        this.hiddenFlatsCount = this.hiddenFlatsList.querySelectorAll('.parametric-flat').length;

        if (Number(totalCount) <= Number(this.hiddenFlatsCount + 3)) {
            this.newCount = totalCount;
            this.showMoreBtn.classList.add('is-hidden');
        } else {
            this.newCount = Number(this.hiddenFlatsCount + 3);
            const rest = totalCount - this.newCount;
            const moreCount = rest < 10 ? rest : 10;
            const words = ['вариант ', 'варианта ', 'вариантов '];
            const restWord = Utils.pluralWord(Number(moreCount), words);

            this.showMoreBtnText.innerHTML = `Еще ${moreCount} ${restWord}`;
        }
    }

    /**
     * Устанавливает новые данные в блок "Показать ещё"
     * @param {Object} more - объект с данными о количестве квартир
     */
    // eslint-disable-next-line max-statements
    setMoreButton(more) {
        if (!this.showMoreBtn) {
            return;
        }

        if (this.beforeUpload) {
            this.showMoreBtn.classList.toggle('is-hidden');

            return;
        }

        if (more.count) {
            if (!this.beforeUpload) {
                this.showMoreBtn.dataset.shown = more.count;
            }

            if (this.flatsCount) {
                this.flatsCount.innerHTML = more.count - this.newCount;
            }

            if (!more.more) {
                this.showMoreBtn.classList.add('is-hidden');
            }
        }

        if (this.showWord && more.count) {
            const words = ['Показан', 'Показаны', 'Показаны'];
            const newShowWord = Utils.pluralWord(Number(more.count), words);

            this.showWord.innerHTML = newShowWord;
        }

        if (this.flatsWord && more.count) {
            const words = ['вариант ', 'варианта ', 'вариантов '];
            const newWord = Utils.pluralWord(Number(more.count), words);

            this.flatsWord.innerHTML = newWord;
        }

        if (this.showMoreBtnText && more.text) {
            this.showMoreBtnText.innerHTML = more.text;
        }
    }

    _subscribes() {
        // Навешивает события на кнопки в попапе для мобилок
        observer.subscribe('popup:open', (popup) => {
            if (popup.currentTarget === this.sortTitleBtn) {
                this.isPopupOpen = true;
                this.sortPopupBtns = Array.from(popup.content.querySelectorAll(this.sortSelector));

                if (this.sortPopupBtns.length) {
                    this.sortPopupBtns.forEach((sort) => {
                        sort.addEventListener('click', this._sort);
                    });
                }
            }
        });

        // Сбрасывает массив кнопок в попапе при закрытии попапа
        observer.subscribe('popup:close', () => {
            if (this.isPopupOpen) {
                this.isPopupOpen = false;
                this.sortPopupBtns = [];
            }
        });
    }

    _bindContext() {
        this._sort = this._sort.bind(this);
        this._showMore = this._showMore.bind(this);
    }

    _initElements() {
        // Сортировка
        this.sortBtns = Array.from(this.element.querySelectorAll(this.sortSelector));
        this.sortTitleBtn = this.element.querySelector('.j-sort-title');
        this.sortTitleName = this.element.querySelector('.j-sort-name');

        // Список квартир
        this.flatsList = this.element.querySelector('.j-parametric__flats-list');

        // Кнопка Показать ещё...
        this.showMoreBtn = this.element.querySelector('.j-parametric__more') || null;
        this.showMoreBtnText = this.showMoreBtn ? this.showMoreBtn.querySelector('.j-parametric__more-text') : null;
        this.flatsCount = this.element.querySelector('.j-parametric__flats-count') || null;
        this.flatsWord = this.element.querySelector('.j-parametric__flats-word') || null;
        this.showWord = this.element.querySelector('.j-parametric__show-word') || null;
        this.complexId = this.element.dataset.complexId;
        this.openList = this.element.querySelector('.j-parametric__open-list') || null;
        this.hiddenFlatsList = this.element.querySelector('.j-parametric__flats-hidden') || null;
    }

    _bindEvents() {
        this.sortBtns.forEach((sort) => {
            sort.addEventListener('click', this._sort);
        });

        if (this.showMoreBtn) {
            this.showMoreBtn.addEventListener('click', this._showMore);
        }

        if (this.openList) {
            this.openList.addEventListener('click', this._openList);
        }

        window.addEventListener('load', this._openSingleList());
    }

    _unbindEvents() {
        this.sortBtns.forEach((sort) => {
            sort.removeEventListener('click', this._sort);
        });

        if (this.showMoreBtn) {
            this.showMoreBtn.removeEventListener('click', this._showMore);
        }
    }

    /* Сортировка */
    _sort(event) {
        const target = event.currentTarget;

        // Устанавливаем новое значение и направление сортировки
        this.sort.sort = target.dataset.sort;
        this.sort.order = target.dataset.order === 'desc' ? 'asc' : 'desc';

        // Меняем DOM сортировочных ссылок
        this._setSort(target);

        // Коллбэк (отправка данных на сервер)
        if (this.options.change) {
            this.options.change(this, 'sort', this._collectData());
        }

        this._toggleMoreBtnState();
    }

    /**
     * Устанавливает классы и параметры для кнопок сортировки
     * @param {Object} targetButton - активная кнопка сортировки
     * @private
     */
    _setSort(targetButton) {
        // Удаляем лишние классы у всех кнопок сортировки,
        // проставляем дефолтное направление сортировки
        [...this.sortBtns, ...this.sortPopupBtns].forEach((button) => {
            button.dataset.order = 'desc';
            button.classList.remove(this.activeClass, this.ascClass, this.descClass);
        });

        // Находим кнопку сортировки в панели, даже если нажата кнопка в попапе
        const initialTargetButton = this.sortBtns.filter((button) => {
            return button.dataset.sort === targetButton.dataset.sort;
        });
        // Исключаем дублирование, если была нажата кнопка в заголовке таблицы результатов
        // В массиве останутся кнопка из попапа, если он есть, и кнопка из заголовка, либо только из заголовка
        const allTargetButtons = [...new Set([...initialTargetButton, targetButton])];

        // Проставляем новое значение у кнопок сортировки
        allTargetButtons.forEach((button) => {
            button.dataset.order = this.sort.order;
            button.classList.add(this.activeClass, `is-${this.sort.order}`);
        });

        this._setSortTitle(targetButton);
    }

    /**
     * Проставляем данные о сортировке в заголовок для мобилки
     * @param {Object} targetButton - активная кнопка сортировки
     * @private
     */
    _setSortTitle(targetButton) {
        this.sortTitleBtn.classList.remove(this.ascClass, this.descClass);
        this.sortTitleBtn.classList.add(`is-${this.sort.order}`);
        this.sortTitleName.innerHTML = targetButton.innerHTML;
    }

    /**
     * Показать ещё
     * @private
     */
    // eslint-disable-next-line max-statements
    _showMore() {
        if (!this.hiddenFlatsList) {
            return;
        }

        // если есть скрытые элементы - открываем и переделываем кнопки, подписи
        if (this.hiddenFlatsList && this.hiddenFlatsList.classList.contains('is-hidden')) {
            this.hiddenFlatsList.classList.remove('is-hidden');
            const totalCount = this.element.querySelector('.j-parametric__total-count').innerHTML;

            this.hiddenFlatsCount = this.hiddenFlatsList.querySelectorAll('.parametric-flat').length;

            if (Number(totalCount) <= Number(this.hiddenFlatsCount + 3)) {
                this.newCount = totalCount;
                this.showMoreBtn.classList.add('is-hidden');
            } else {
                this.newCount = Number(this.hiddenFlatsCount + 3);
                const rest = totalCount - this.newCount;
                const moreCount = rest < 10 ? rest : 10;
                const words = ['вариант ', 'варианта ', 'вариантов '];
                const restWord = Utils.pluralWord(Number(moreCount), words);

                this.showMoreBtnText.innerHTML = `Еще ${moreCount} ${restWord}`;
            }

            this.flatsCount.innerHTML = this.newCount;
            this.beforeUpload = true;

            if (this.showWord) {
                const words = ['Показан', 'Показаны', 'Показаны'];
                const newShowWord = Utils.pluralWord(Number(this.newCount), words);

                this.showWord.innerHTML = newShowWord;
            }

            if (this.flatsWord) {
                const words = ['вариант ', 'варианта ', 'вариантов '];
                const newWord = Utils.pluralWord(Number(this.newCount), words);

                this.flatsWord.innerHTML = newWord;
            }

            return;
            // препятствует подгрузке новой порции квартир с сервера
        } else if (!this.hiddenFlatsList.classList.contains('is-hidden')) {
            this.newCount = 0;
            this.beforeUpload = false;

            // подменяет текст на кнопке Ещё дата-атрибутом, если он есть
            if (this.showMoreBtn.dataset.moreBtn) {
                this.showMoreBtnText.innerHTML = this.showMoreBtn.dataset.moreBtn;
            }
        }

        if (this.options.change) {
            this.options.change(this, 'more', this._collectData());
        }
    }

    /**
     * Принудительно раскрывает список единственного объекта на мобильном
     */
    _openSingleList() {
        const complexes = document.querySelectorAll('.j-parametric-complex');

        if (complexes.length < 2) {
            const list = complexes[0].querySelector('.parametric-complex__flats-list');
            const more = complexes[0].querySelector('.parametric-complex__more');

            list.classList.add('is-active');

            if (more) {
                more.classList.add('is-active');
            }

            if (this.openList) {
                this.openList.classList.add('is-hidden');
            }
        }
    }

    /**
     * Раскрыть список на мобильном
     */
    _openList() {
        const list = this.closest('.j-parametric-complex').querySelector('.parametric-complex__flats-list');
        const more = this.closest('.j-parametric-complex').querySelector('.parametric-complex__more');
        const line = this.querySelector('.button__inner .button__text');

        list.classList.toggle('is-active');
        if (more) {
            more.classList.toggle('is-active');
        }
        this.classList.toggle('opened');

        if (line) {
            if (this.classList.contains('opened')) {
                line.textContent = 'Скрыть';
            } else {
                line.textContent = 'Показать';
            }
        }

        observer.publish('parametricListOpened');
    }

    /**
     * Собирает данные для отправки
     * @returns {Object} data
     * @private
     */
    _collectData() {
        const data = {};

        this._addComplexId(data);
        this._addSort(data);
        this._addLimit(data);

        return data;
    }

    /**
     * Добавляет id комплекса в данные для отправки
     * @param {object} data - объект данных
     * @private
     */
    _addComplexId(data) {
        if (this.complexId) {
            data.complexId = this.complexId;
        }
    }

    /**
     * Добавляет сортировку в данные для отправки
     * @param {Object} data - объект данных
     * @private
     */
    _addSort(data) {
        data.sort = this.sort.sort;
        data.order = this.sort.order;
    }

    /**
     * Добавляет кол-во выведенных квартир в данные для отправки
     * @param {Object} data - объект данных
     * @private
     */
    _addLimit(data) {
        if (!this.showMoreBtn) {
            return;
        }
        data.shown = this.showMoreBtn.dataset.shown;
    }

    /**
     * Передаёт данные о квартирах в dataLayer
     * @param {Object} flats - данные о квартирах
     * @private
     */
    _sendDataLayerFlats(flats) {
        const products = [];

        for (const flat of flats) {
            products.push({
                id   : flat.id,
                price: flat.price ? flat.price.replace(/\s/g, '') : '0'
            });
        }

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'ViewCategory',
            products
        });
    }
}

export default ParametricComplex;
